import React, { useContext } from "react";
import "./Sharing.scss";
import { ReactComponent as WhatsApp } from "../../assets/media/whatsapp.svg";
import { ReactComponent as Facebook } from "../../assets/media/facebook.svg";
import { ReactComponent as Twitter } from "../../assets/media/twitter.svg";
import { ReactComponent as LinkedIn } from "../../assets/media/linkedin.svg";
import { I18nContext } from "../../context";
import { replacePlaceholders } from "../../lib/helpers";
import { ResultRanking, ResultPercentage } from "../Result/Result";
// import { serializeIncome } from "../../lib/calculator";
// import SharingImage from "./SharingImage";

/**
 * Render sharing links
 * @param {Object} props
 * @param {String} props.url URL to share
 * @param {Object} props.income Data entered
 * @param {Object} props.region Selected region
 * @param {Object} props.result API response
 * @returns {React.ReactElement}
 */
function Sharing({ url, income, region, result }) {
  const { locale } = useContext(I18nContext);

  const encodedUrl = encodeURIComponent(url);
  // const prefilledIncome = serializeIncome(income);
  // const prefilledEncodedUrl = encodeURIComponent(
  //   `${url}#prefilled=${JSON.stringify(prefilledIncome)}`
  // );

  const message = replacePlaceholders(locale.sharingMessage, { url });
  const encodedMessage = encodeURIComponent(message);

  const targets = [
    {
      Icon: WhatsApp,
      url: `https://api.whatsapp.com/send?text=${encodedMessage}`,
      label: locale.sharingWhatsAppLabel,
    },
    {
      Icon: Facebook,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      label: locale.sharingFacebookLabel,
    },
    {
      Icon: Twitter,
      url: `https://twitter.com/intent/tweet?text=${encodedMessage}`,
      label: locale.sharingTwitterLabel,
    },
    {
      Icon: LinkedIn,
      url: `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}`,
      label: locale.sharingLinkedInLabel,
    },
  ];

  return (
    <div className="Sharing">
      <div className="Sharing__inner">
        <h3 className="Sharing__title">{locale.sharingTitle}</h3>
        <div className="Sharing__results">
          {result.isTop ? null : <ResultRanking {...{ result }} />}
          <ResultPercentage {...{ region, result }} />
        </div>
        <div className="Sharing__actions">
          <ul className="Sharing__items">
            {targets.map((target) => (
              <li className="Sharing__item" key={target.label}>
                <a
                  className="Sharing__link"
                  href={target.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <target.Icon className="Sharing__link-icon" />
                </a>
              </li>
            ))}
          </ul>
          <p className="Sharing__text">{locale.sharingText}</p>
          {/* <SharingImage {...{ region, result }} /> */}
        </div>
      </div>
    </div>
  );
}

export default Sharing;
